module.exports = __webpack_public_path__ + "static/about-me-banner-24fd576aa94d5645fa762e5f35b410ba.jpg";